<template>
    <div>
      <div class="modal hide fade" id="modalGetOnHandForm" tabindex="-1" role="dialog" aria-labelledby="modalGetOnHandForm" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">On Hand</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label for="product_no" class="col-form-label">Product:</label>
                  <v-select :options="getProductSelect" :reduce="product => product.meta.code" label="product" v-model="addProduct.product_no"/>
                </div>
                <div class="form-group">
                  <label for="qty" class="col-form-label">Ukuran Potong:</label>
                  <input type="text" class="form-control" v-model="addProduct.qty_stock">
                </div>
                <div class="form-group">
                  <label for="qty" class="col-form-label">Uom:</label>
                  <select class="form-control form-control-lite" v-model="addProduct.uom_id">
                    <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="qty" class="col-form-label">Qty:</label>
                  <input type="text" class="form-control" v-model="addProduct.qty">
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button class="btn btn-sm btn-primary" @click="process" data-dismiss="modal">Add Product</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'InventoryOnHandFormModal',
  props: ['addProduct'],
  computed: {
    ...mapState({
      productListSelect: state => state.products.productListSelect,
      uomList: state => state.uom.uomList
    }),
    getProductSelect () {
      var array = this.productListSelect
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          product: '[' + array[i].product_no + '] ' + array[i].product_name,
          meta: {
            code: array[i].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  methods: {
    process () {
      this.$emit('processAddProduct', this.addProduct)
    }
  }
}
</script>
